import SearchMapModal from '@ui/Search/Map/Modal/component'
import ElementPropertiesManager from 'assets/core/js/module/elementPropertiesManager'

export const openMap = (productId: string): void => {
  const mapEl = document.getElementById('search-map-modal-container')

  if (!mapEl) {
    return
  }

  const map = ElementPropertiesManager.getProperty<SearchMapModal>(mapEl, 'searchMapModal')

  if (!map) {
    mapEl.addEventListener('map-initialized', () => {
      const initializedMap = ElementPropertiesManager.getProperty<SearchMapModal>(mapEl, 'searchMapModal')
      initializedMap?.map?.openMarker(productId)
    })
  } else {
    mapEl.addEventListener(
      'map-query-done',
      () => {
        map.map?.openMarker(productId)
      },
      { once: true }
    )

    map.map?.openMarker(productId)
  }

  document.getElementById('toggle-map')?.click()
}

export default (): SearchMapModal | undefined => {
  const mapEl = document.getElementById('search-map-modal-container')

  if (!mapEl) {
    return
  }

  const map = new SearchMapModal(mapEl)

  document.addEventListener('click', (e) => {
    const target = e.target as HTMLElement

    if (target?.classList.contains('toggle-map-link')) {
      const markerId = target.getAttribute('data-id') as string

      openMap(markerId)
    }
  })

  document.querySelectorAll('.toggle-map__button').forEach((el) => {
    el.addEventListener('click', () => {
      map.open()
    })
  })

  return map
}
